import { MedRecSwitch, SearchHeader, StoreLocator } from '@/components';

import {
  HeaderBurgerNav,
  HeaderFavorites,
  HeaderLogo,
  HeaderProfile,
  HeaderRow,
  HeaderSection,
  HeaderShopping,
} from '../../Header.components';

import styles from './withTopLocatorAndBottomNav.module.scss';

const HeaderWithTopLocatorAndBottomNavMobile = () => (
  <>
    <HeaderRow borderless type="small">
      <HeaderSection justify="start">
        <HeaderBurgerNav />
        <HeaderLogo fullWidth />
      </HeaderSection>
      <HeaderSection justify="end">
        <HeaderProfile />
        <HeaderFavorites />
        <HeaderShopping />
      </HeaderSection>
    </HeaderRow>
    <HeaderRow borderless relativePosition type="flat">
      <HeaderSection justify="center">
        <SearchHeader className={styles.search__header} />
      </HeaderSection>
    </HeaderRow>
    <HeaderRow type="small">
      <HeaderSection justify="center" spaceBetweenOnMultipleChildren>
        <StoreLocator />
        <MedRecSwitch />
      </HeaderSection>
    </HeaderRow>
  </>
);

export { HeaderWithTopLocatorAndBottomNavMobile };
